$(function () {
  const worksWrapper = $("#js_worksWrapper");
  const youtubearea = $("#ly_youtubeArea");
  let youtubearea_position = youtubearea.offset().top;
  $(window).on("scroll", function () {
    if ($(this).scrollTop() > youtubearea_position) {
      worksWrapper.css({ display: "none" });
    } else {
      worksWrapper.css({ display: "block" });
    }
  });
});
